class CookieConsentContentWrapper {
    addedContent = false

    constructor(element) {
        // set dom elements
        this.contentElement = element
        this.contentTarget = element.querySelector('.js-cookie-consent-content__target')
        this.contentReplacement = element.querySelector('.js-cookie-consent-content__replacement')
        this.contentReplacementTeaser = element.querySelector('.js-cookie-consent-content__replacement-teaser')
        this.contentReplacementLoading = element.querySelector('.js-cookie-consent-content__replacement-loading')

        // set configuration
        this.id = this.contentElement.dataset['contentIdentifier']
        this.allowedCookieGroup = this.contentElement.dataset['cookieGroup']

        this.initCookieConsentContent()
    }

    /**
     * Content is loaded if it is allowed or the permission was granted by the user
     */
    initCookieConsentContent() {
        this.loadContentIfAllowed()
    }

    /**
     * handles when user rejects or accepts
     * @param content
     */
    loadContentIfAllowed() {
        const activeGroups = OnetrustActiveGroups.split(',')

        // Checks if the OnetrustActiveGroups contain the cookie group selected in the backend
        if (activeGroups !== undefined && !this.addedContent && activeGroups.indexOf(this.allowedCookieGroup) >= 0) {
            //If so, the content is loaded from the endpoint and placed in the target div
            if (this.content !== undefined) {
                this.injectContent()
            } else {
                this.requestContent()
            }
        }
        //If the content has been injected already, but the group is not allowed, the content is removed
        else if (this.addedContent && activeGroups.indexOf(this.allowedCookieGroup) < 0) {
            this.contentTarget.innerHTML = ''
            this.addedContent = false
            // show replacement text
            this.contentReplacementTeaser.style.display = 'block'
            this.contentReplacementLoading.style.display = 'none'
            this.contentReplacement.classList.remove('hidden')
        } else {
            // show replacement text
            this.contentReplacementTeaser.style.display = 'block'
            this.contentReplacementLoading.style.display = 'none'
            this.contentReplacement.classList.remove('hidden')
        }
    }

    /**
     * Requests the content from the endpoint and triggers injection if successful
     */
    requestContent() {
        // show loading icon
        this.contentReplacementTeaser.style.display = 'none'
        this.contentReplacementLoading.style.display = 'block'
        this.contentReplacement.classList.remove('hidden')
        // request content
        this.request = new XMLHttpRequest()
        this.request.open('GET', '/cookie-consent-content?id=' + this.id, true)
        this.request.send(null)
        this.request.onreadystatechange = () => {
            if (this.request.readyState == 4) {
                this.content = this.request.responseText
                this.injectContent()
            }
        }
    }

    /**
     * Inject content into target div
     */
    injectContent() {
        this.setInnerHTML(this.contentTarget, this.content)
        this.addedContent = true
        this.contentReplacement.classList.add('hidden')

        // fire event to listen on other plugins
        const cookieConsentEvent = new Event('afterCookieConsent')
        document.dispatchEvent(cookieConsentEvent)
    }

    /**
     * Script tags inside the html content need to be initialized to be executed
     * https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml
     * @param elm
     * @param html
     */
    setInnerHTML(elm, html) {
        elm.innerHTML = html
        Array.from(elm.querySelectorAll('script')).forEach((oldScript) => {
            const newScript = document.createElement('script')
            Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value))
            newScript.appendChild(document.createTextNode(oldScript.innerHTML))
            oldScript.parentNode.replaceChild(newScript, oldScript)
        })
    }
}

/**
 * Initializes all CookieConsentContent elements on the page
 */
export default function initializeCookieConsentContentWrapper() {
    if (typeof window.OneTrust !== 'undefined') {
        var cookieConsentElements = document.querySelectorAll('.js-cookie-consent-content')
        var cookieConsentContentObjects = []
        for (let i = 0; i < cookieConsentElements.length; i++) {
            let cookieConsentElementObject = new CookieConsentContentWrapper(cookieConsentElements[i])
            cookieConsentContentObjects.push(cookieConsentElementObject)
        }
        //Add the onetrust changed event outside of the cookieConsent object, otherwise it doesn't work
        OneTrust.OnConsentChanged(() => {
            cookieConsentContentObjects.forEach((cookieConsentContentObject) => {
                // Add listener in case the user rejects or accepts
                cookieConsentContentObject.initCookieConsentContent()
            })
            // fire event to listen on other plugins
            const cookieConsentEvent = new Event('afterCookieConsent')
            document.dispatchEvent(cookieConsentEvent)
        })
    } else {
        // This workaround was required since there seems to be no event firing, when OneTrust is available
        // Please refactor if a better way is available
        setTimeout(initializeCookieConsentContentWrapper, 250)
    }
}
